import { usersRepo } from '@/constants/providers';
import { MutationOptions } from '@/core/types/mutation-options';
import { ApiResponse } from '@/shared/types';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { UserKey } from './types';

export const useDisableUser = (options: MutationOptions = {}) => {
  const queryClient = useQueryClient();
  const { t } = useTranslation();
  return useMutation<ApiResponse<unknown>, unknown, number>(
    (id) => usersRepo.disableUser(id),
    {
      onSuccess: () => {
        toast.success(t('success_disable_user'));
        queryClient.invalidateQueries(UserKey.ALL);
        options.onSuccess?.();
      },
      onError: (error) => {
        toast.error(t('error_change_user_status'));
        options.onError?.(error);
      },
    },
  );
};
